import React from 'react'
import { Card } from 'react-bootstrap'

const VRDevelopmentBanner = () => {
  return (
    <>
      <Card className="digital-twin-banner no-border rounded-0">
            <Card.Img src={"/assets/vr-development/top-banner.jpg"} alt="Card image" className="banner-image rounded-0"  />
        </Card>
        <Card className="no-border rounded-0 text-center container">
            <Card.Title className='digital-twin-title'> バーチャルリアリティ（VR）開発 </Card.Title>
            <Card.Subtitle className='digital-twin-subtitle'> ようこそ別世界へ </Card.Subtitle>
            <Card.Text className='digital-twin-text text-left'>
            VRでは、あらゆることが可能になります。安全上のリスクを伴わずにオペレーターに仕事を教えたり、学生が地球上のあらゆる史跡を訪ねたり、ゲームがこれまで以上にインタラクティブで臨場感のあるものになります。
            <br />
            <br />   
            完全なEND TO ENDのVR開発ソリューション、バーチャル空間、プロジェクト用の3Dアセットなど、パラコズマはお客様のご要望に応じたリソースとソリューションを提供します。
            </Card.Text>
        </Card>
    </>
  )
}

export default VRDevelopmentBanner
